export const langText = {
  ko:{
    header:{
      language:"English"
    },
    main:{
      title:"현실로 \n 전환되는",
      desc:"차세대 기술의 꿈"
    },
    blockChain:{
      title:"블록체인",
      desc:"블록체인을 이용한 다양한 NFT 마켓 플레이스 구축 경험을 가진\n 트라움은 지적재산권 보호를 위해 이 경험을 적극 활용하고자\n 합니다. 이를 통해 예술인과 트레이더들이 자신만의 노하우의\n 가치를 정당하게 인정받을 수 있는 세상을 구축하려합니다."
    },
    trading:{
      title:"트레이딩",
      desc:"트레이딩 시 발생하는 피로도와 진입의 부담감을 덜 수 있는\n서비스를 제공합니다. 투자에 낯선 일반인도 트라움의 서비스를\n 통해 안전하게 거래할 수 있습니다. 특화되고 전문적인 백테스팅\n 데이터를 바탕으로 차세대 솔루션을 선도할 수 있도록 몰입하고\n 있습니다."
    },

    onlyTraum:{
      title:"오직,\n트라움에서만",
      service:[
        { 
          title:"24시간\n붙어 있는\n비서처럼",
          desc:"개인 투자자가 한정된 시간에\n효율적으로 트레이딩 할 수\n있도록 도와드립니다.",
          defaultImg:"/imgs/home/coinButler.png",
          hoverImg:"/imgs/home/coinButlerHover.png",
          logoImg:"/imgs/home/coinButlerLogo.png"
        },
        {
          title:"자동\n트레이딩의\n척척박사",
          desc:"인공지능이 저항선과 지지선\n구간을 감지하며 초보자의\n트레이딩을 도와드립니다.",
          defaultImg:"/imgs/home/gridButler.png",
          hoverImg:"/imgs/home/gridButlerHover.png",
          logoImg:"/imgs/home/gridButlerLogo.png"
        },
        {
          title:"한 손에\n잡히는\n재정거래",
          desc:"가격의 등락에 의한 손실을 방어하고\n종목 분석 및 매매 타이밍의 분석의\n필요성이 저하되는 장점을 지니고\n있는 서비스 입니다.",
          defaultImg:"/imgs/home/arbiButler.png",
          hoverImg:"/imgs/home/arbiButlerHover.png",
          logoImg:"/imgs/home/arbiButlerLogo.png"

        },
        {
          title:"안정적인\n지적 재산권의\n보호자",
          desc:"자신이 창조한 아이템이나 트레이딩\n전략을 NFT화하여 수익을 낼 수 있고,\n구매자는 전문가의 투자 방식을\n간편하게 활용할 수 있습니다.",
          defaultImg:"/imgs/home/contentShopper.png",
          hoverImg:"/imgs/home/contentShopperHover.png",
          logoImg:"/imgs/home/contentShopperLogo.png"
        }
      ]
    },

    
    footer:{
      address:"서울 강서구 공항대로 242, 6층 611-1호"
    },
    
    
    // about
    traumPath:{
      text:"트라움\n나아가는 길."
    },

    wayForward:{
      imgSrc:"/imgs/about/vision_ko.png"
    },
    
    worldInTraum:{
      title:"세상에 나타난 트라움",
      news:[
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        },
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        },
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        },
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        },
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        },
        {
          news:"연합뉴스",
          date:"2022.03",
          newsTitle:"트라움, 3년째 수익 30% 유지" 
        }
      ]
    },
    
    value:{
      title:"트라움만의 가치 철학",
      content:[
        {
          imgSrc:"/imgs/about/value1.png",
          title:"조직문화",
          desc:"트라움은 두려움 없이 문제를 직면합니다. 능동적인 자세를 취하며 새로움을 개척하기 위해 적극적으로 달려갑니다."
        },
        {
          imgSrc:"/imgs/about/value2.png",
          title:"업무환경",
          desc:"팀원에게 가장 솔직하고 그릇되지 않습니다. 해결할 문제를 공명정대하게 판단하기 위해 한 의견에 치우치지 않고, 사소한 의견 하나라도 진중하게 대하고 있습니다."
        },
      ]
    },

    history:{
      title:"연혁",
      achievement:[
        {
          year:2022,
          desc:[
            "로보어드바이저 플랫폼 부문 혁신 금융 대상 수상",
            "한국외국어대학교 캡스톤 디자인 멘토 기업 참여",
            "블록체인 우수기업 간담회 참여",
            "부산광역시 블록체인산업 업무협약 체결",
            "트라움X롯데정보통신 NFT 마켓플레이스 구축",
            "외대 캡스톤 프로젝트 베스트 페이퍼",
            "2022 BWB 기업 부분 참가"
          ]
        },
        {
          year:2021,
          desc:[
            "NFT 마켓플레이스 개발 (싱카폴 소재)",
            "글로벌 순위권 OKEx와 공식 API",
            "브로커 계약 체결"
          ]
        },
        {
          year:2020,
          desc:[
            "바이낸스와 공식 API 브로커 계약 체결",
            "FTX와 파트너십 체결",
            "한국외대 파트너십 협약 체결"
          ]
        },
        {
          year:2019,
          desc:[
            "EOS 노트 지갑 및 토큰 전송 어드민 페이지 개발 (미국 제공)",
            "재정거래 알고리즘 수정 및 재설계 계약 (우크라이나 소재)"
          ]
        },
        {
          year:2018,
          desc:[
            "트라움인포테크 법인 설립"
          ]
        },
        {
          year:2017,
          desc:[
            "트레이딩 솔루션 프로토타입 제작 및 검증"
          ]
        },
      ]
    },

    more:{
      text:"트라움에 대해 더 알아보세요"
    }
  },

  en:{
    header:{
      language:"한국어"
    },
    main:{
      title:"The Present \n Of Future",
      desc:"Technology Dream"
    },
    blockChain:{
      title:"Block Chain",
      desc:"Traum, who has experience in building various NFT\n marketplaces using blockchain, wants to actively\n utilize this experience to protect intellectual propertyrights.\nThrough this, we will build a world where artists and traders\n can be duly recognized for their own know-how,\nwant to do it."
    },
    trading:{
      title:"Trading",
      desc:"we can reduce the fatigue and burden of entry that\n occurs during trading.Even ordinary people unfamiliar\nwith investing can safely trade through Traum's service.\n We are immersed in leading next-generation solutions\n based on specialized and professional backtesting data."
    },
    onlyTraum:{
      title:"Only, Traum",
      service:[
        {
          title:"24 hours,\nand like\nsecretary",
          desc:"We help that a personal\ninvestors can trade efficiently\nin limited time.",
          defaultImg:"/imgs/home/coinButler.png",
          hoverImg:"/imgs/home/coinButlerHover.png",
          logoImg:"/imgs/home/coinButlerLogo.png"
        },
        {
          title:"A master of\nautomatic\ntrading",
          desc:"AI detection of resistance\nand support level, and help\nbeginner’s trading",
          defaultImg:"/imgs/home/gridButler.png",
          hoverImg:"/imgs/home/gridButlerHover.png",
          logoImg:"/imgs/home/gridButlerLogo.png"
        },
        {
          title:"Arbitrage\nin my hand",
          desc:"Defends losses due to price\nfluctuations. It also has the advantage\n of reducing the need for stock\nanalysis and trading timing analysis.",
          defaultImg:"/imgs/home/arbiButler.png",
          hoverImg:"/imgs/home/arbiButlerHover.png",
          logoImg:"/imgs/home/arbiButlerLogo.png"
        },
        {
          title:"A copyright\nguardian",
          desc:"Register your creations in a\nmarketplace and earn revenue. In here,\n traders can NFT their strategies and\n sell them. If you buy it, you can have\nunder control and take advantage of\nthe professional investment knowhow.",
          defaultImg:"/imgs/home/contentShopper.png",
          hoverImg:"/imgs/home/contentShopperHover.png",
          logoImg:"/imgs/home/contentShopperLogo.png"
        }
      ]
    },
    footer:{
      address:"242, Gonghang-daero, Gangseo-gu, Seoul, Republic of Korea"
    },






    // about

    traumPath:{
      text:"The future\nwhat we walk."
    },
    wayForward:{
      imgSrc:"/imgs/about/vision_en.png"
    },

    worldInTraum:{
      title:"World In Traum",
      news:[
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
        {
          news:"YeonhapNews",
          date:"2022.03",
          newsTitle:"30% yield for 3 years" 
        },
      ]
    },

    value:{
      title:"Value",
      content:[
        {
          imgSrc:"/imgs/about/value1.png",
          title:"Organizational Culture",
          desc:"Traum boldly confronts challenges without fear. It adopts a proactive stance and actively runs towards pioneering innovation."
        },
        {
          imgSrc:"/imgs/about/value2.png",
          title:"Work Environment",
          desc:"We are honest and impartial with my team members. and treat every opinion seriously and with respect, without being swayed by biases, in order to make fair judgments when addressing the issues at hand."
        },
      ]
    },
    history:{
      title:"History",
      achievement:[
        {
          year:2022,
          desc:[
            "Roadvisor Platform Award Winner of Innovative Finance",
            "Participating in Capstone Design Mentor Company at Hankuk University of Foreign Studies",
            "Participating in a meeting of top blockchain companies",
            "with Busan  Signs Business Agreement for Blockchain Industry",
            "[TraumXLotte] Development of NFT Marketplace",
            "The best paper on the Capstone Project at Hankuk University of Foreign Studies",
            "2022 BWB corporation sector participation"
          ]
        },
        {
          year:2021,
          desc:[
            "Development of NFT Marketplace",
            "Signed official API broker contract with global ranking OKEx"
          ]
        },
        {
          year:2020,
          desc:[
            "Formal API Broker Agreement With Binance",
            "Partnership with FTX",
            "Partnership with Hankuk University of Foreign Studies"
          ]
        },
        {
          year:2019,
          desc:[
            "Dveloping EOS wallet and to sending token’s admin page ",
            "Arbitrage Algorithm Modification and Redesign Agreement"
          ]
        },
        {
          year:2018,
          desc:[
            "Incorporation"
          ]
        },
        {
          year:2017,
          desc:[
            "Producting and Verification a trading solution"
          ]
        },
      ]
    },
    more:{
      text:"see more us"
    }
  }
}